import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import {
  ProductUsageProgramScheduleResource,
  productUsageProgramScheduleSchema,
} from "@client/resources/ProductUsageProgramScheduleResource";

export type FetchProductUsageParams = {
  programId: number;
  from: string;
  to: string;
  productId: number;
};

export type FetchProductUsageResponse = ApiResponse<
  ProductUsageProgramScheduleResource[]
>;

export const fetchProductUsage = async (
  params: FetchProductUsageParams,
): Promise<FetchProductUsageResponse> => {
  const response = await fetchData(
    `/dietitian/programs/{program_id}/schedule/product-usage`.replace(
      "{program_id}",
      params.programId.toString(),
    ),
    APIMethods.GET,
    undefined,
    mapUrlParams(params),
  );

  return await schema
    .validate(response)
    .catch(
      logFetchValidateError(
        "/dietitian/programs/{program_id}/schedule/product-usage",
      ),
    );
};

const mapUrlParams = (params: FetchProductUsageParams) => {
  const urlParams = new URLSearchParams();

  urlParams.set("from", params.from);
  urlParams.set("to", params.to);
  urlParams.set("product-id", params.productId.toString());

  return urlParams;
};

const schema = yup.object({
  data: yup.array().of(productUsageProgramScheduleSchema).defined(),
});
